"use client";

import Link from "next/link";
import React from "react";
import { Button } from "react-bootstrap";
import styles from "./DomainFind.module.css";

interface DomainFindProps {
  title?: string;
  subtitle?: string;
  placeholder?: string;
  buttonText?: string;
  actionUrl: string;
}

const DomainFind: React.FC<DomainFindProps> = ({
  title = "Find your domain name",
  subtitle = "Search for your dream domain now",
  placeholder = "Find Your Perfect Domain Name",
  buttonText = "Search",
  actionUrl,
}) => {
  return (
    <section className={styles.wrapper}>
      <div className="container">
        <h1 className={`text-center fw-bold ${styles.heading}`}>{title}</h1>
        <p className={`text-center ${styles.subtext}`}>{subtitle}</p>

        <div className="d-flex justify-content-center">
          <div className="col-lg-8 col-md-10 col-12"> 
            {/* Desktop View */}
            <form
              className={`d-none d-md-flex align-items-center ${styles.searchBox}`}
              action={actionUrl}
              method="post"
            >
              <input
                type="text"
                name="a"
                placeholder={placeholder}
                className={styles.input}
              />

              <Link
                href="https://clients.temok.com/cart.php?a=add&domain=register"
                className={styles.linkButton}
              >
                <Button className={styles.button}>{buttonText}</Button>
              </Link>
            </form>

            {/* Mobile View */}
            <form
              className={`d-flex d-md-none flex-column ${styles.searchBoxMobile}`}
              action={actionUrl}
              method="post"
            >
              <input
                type="text"
                name="a"
                placeholder={placeholder}
                className={styles.inputMobile}
              />

              <Link
                href="https://clients.temok.com/cart.php?a=add&domain=register"
                className={styles.linkButton}
              >
                <Button className={`${styles.button} mx-auto d-block`}>{buttonText}</Button>
              </Link>
            </form>

          </div>
        </div>
      </div>
    </section>
  );
};

export default DomainFind;
